import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ActionStatus } from '@/application/types';
import { OrderIdentification } from '../../types';

const orderSearchState = namespace('orderSearch');

@Component
export default class SearchResults extends Vue {

  @orderSearchState.State
  orderIdentifications!: OrderIdentification[];

  @orderSearchState.State
  getOrderIdentificationsByOrderNumberStatus!: ActionStatus;

  @orderSearchState.State
  lastSearchTerm!: string;

  @orderSearchState.State
  hasSearchBeenTriggered!: boolean;

  @orderSearchState.State
  hasSearchResultedIn0Results!: boolean;

  get isLoading(): boolean {
    return this.getOrderIdentificationsByOrderNumberStatus === ActionStatus.InProgress;
  }

  get isListShown(): boolean {
    return !this.isLoading && this.orderIdentifications.length > 0;
  }

  get isEmptyStateShown(): boolean {
    return !this.isLoading && !this.hasSearchBeenTriggered;
  }

  get isNoResultsShown(): boolean {
    return !this.isLoading && this.hasSearchBeenTriggered && this.hasSearchResultedIn0Results;
  }

}
